module.exports = __webpack_public_path__ + "static/media/wallet.5e098eed.png";